import React from "react";
import PropTypes from "prop-types";
import { Button } from "@learningblocks/shared-components";
import style from "./style.module.scss";
/**
 * SubmitButton
 *  - Submit  button for Question Components
 */
export function SubmitButton(props) {
  const className = `${style.button} ${props.className}`;

  return (
    <Button
      onClick={props.onSubmit}
      disabled={props.disabled}
      className={className}
    >
      {props.label}
    </Button>
  );
}

SubmitButton.propTypes = {
  /**
   * Boolean value controlling button enabled/disabled
   */
  disabled: PropTypes.bool.isRequired,
  /**
   * Callback function involked on button Click
   */
  onSubmit: PropTypes.func.isRequired,
  /**
   * className to set on component
   */
  className: PropTypes.string,
  /**
   * Label shows on the reset button component
   */
  label: PropTypes.string,
};

SubmitButton.defaultProps = { className: "", label: " Submit answer" };
